export enum PoolShellStatusEnum {
    Pendiente = 1,
    Programada = 2,
    Lista = 3,
    Modificada = 4
}
